import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PortalRoutingModule } from './portal-routing.module';
import { PortalComponent } from './portal.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from "@angular/forms";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NavigationModule } from '@tangilla/tg-ng-layout/src/lib/navigation';
import { SpinnerModule } from '@tangilla/tg-ng-common/src/lib/components';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormDateTimePickerModule } from '@tangilla/tg-ng-common';
import { MatToolbarModule } from '@angular/material/toolbar';

@NgModule({
  declarations: [
    PortalComponent,
  ],
  imports: [
    CommonModule,
    PortalRoutingModule,
    ReactiveFormsModule,
    NavigationModule,
    FlexLayoutModule,
    MatNativeDateModule,
    MatDatepickerModule,
    FormDateTimePickerModule,
    MatProgressBarModule,
    SpinnerModule,
    MatToolbarModule
  ],
  providers: []
})
export class PortalModule {
}
